import React from "react";

import * as Styles from './Footer.styles.js';


const Footer = props => (
  <Styles.Container>
    <p>Powered by guinea pigs. <a href="#top">Back to top</a></p>
  </Styles.Container>
);

export default Footer;